<template>
  <div class="award_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t("user.receiveAward") }}
      </div>
    </div>
    <div class="award_box">
      <div>
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
        >
          <div class="list">
            <div
              v-for="item in list"
              :key="item.id"
              class="item"
            >
              <div class="dage">
                <div class="state">
                  {{ $t("user.award") }}
                </div>
              </div>
              <div class="price">
                <p><span class="cost">{{ item.jlmoney }}</span></p>
              </div>
              <div class="rule">
                <p class="title">
                  {{ item[`title_${lang}`] }}
                </p>
               
                <div class="progress">
                  <span class="txt">
                    {{ effective }}/{{ item.num }}
                  </span>
                  <div class="bg-prosess bg-line">
                    <div
                      class="line inner"
                      :style="{width:item.progress}"
                    />
                  </div>
                </div>
                <p class="tip">
                  {{ item.people }}
                </p>
              </div>
              <div v-if="effective>=item.num"> 
                <van-button
                  v-if="item.is_receive==0"
                  color="#AA8E6A"
                  size="small"
                  round
                  class="btn"
                  @click="handleSign(item)"
                >
                  {{ $t("sign.sign") }}
                </van-button>
                <van-button
                  v-if="item.is_receive==1"
                  size="small"
                  round
                  class="btn"
                  type="info"
                >
                  {{ $t("sign.signed") }}
                </van-button>
              </div>
              <div v-else>
                <van-button
                  size="small"
                  round
                  class="btn"
                  type="primary"
                  @click="handletoFinish"
                >
                  {{ $t("user.toFinish") }}
                </van-button>
                <!--  -->
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { DropdownMenu, DropdownItem,List,Cell,Button,Progress} from "vant";

import { Empty } from "vant";

Vue.use(Empty);
Vue.use(DropdownMenu).use(DropdownItem).use(List).use(Cell).use(Button).use(Progress);

export default {
  name: "WithdrawRecord",
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      loading:false,
      effective:0,
      data: [],
      list: [],
      account: 0,
      option: [],
      listShow: false,
      funds: 0,
      userName: "",
      finished:false
    };
  },
  computed:{
  },
  created() {
    this.$parent.footer("user", false);
  },
  mounted() {
     this.getList()
  },
  methods: {
     processMath(total,num){
         num=num>=total?parseFloat(total*1):parseFloat(num*1)
         const result = Math.round(num / total * 10000) / 100.00 
         return result+"%"
      },
    onLoad(){
    this.finished=true
    },
    getList(){
       Fetch("/user/fxactivity").then((r) => {
      this.list = r.data.list.reverse()
      this.effective=r.data.effective
      this.list.forEach(v=>{
        v.progress=this.processMath(v.num,r.data.effective)
        v.people=this.$t("user.shareNum").replace(/&people/g,v.num)
      })
    });
    },
    /**
     * 领取
     * @param {any} item
     * @returns {any}
     */
    handleSign(item){
      console.log(item.id,9999)
       Fetch("/user/receive", {
        id: item.id,
      }).then((r)=>{
        this.getList()
        this.$toast({
          background: "#07c160",
          message: this.$t("user.receivedsuccessfully"),
        });
        console.log(r,"领取成功")
      })
    },
    /**
     * 去完成
     * @returns {any}
     */
    handletoFinish(){
   this.$router.push('/myTeam')
    }
  },
};
</script>

<style lang="less" scoped>
.award_wrap {
  background-color : #FFFFFF;
  min-height : 100%;
  max-height : fit-content;
}
.red_top_bg {
  height : 126px;
  background : #3775F4;
  position : fixed;
}
.award_box {
  text-align : center;
  width : 100%;
  position : absolute;
  top : 78px;
  background : #FFFFFF;
  // left: 2%;
  border-radius : 5px 5px 0 0;
  padding : 20px 0;
  .list {
    padding : 0 12px;
    margin-bottom : -20px;
    width : 100%;
    max-width : 750px;
    .item {
      position : relative;
      display : flex;
      align-items : center;
      background-color : #2F3143 ;
      height : 100px;
      margin-bottom : 20px;
      border-radius : 8px;
      overflow : hidden;
      padding : 0 10px;
      .dage {
        position : absolute;
        border-top : 40px solid #AA8E6A ;
        border-right : 40px solid transparent;
        width : 0;
        top : 0;
        left : 0;
        height : 0;
        .state {
          width : max-content;
          color : #FFFFFF;
          font-size : 6px;
          transform : rotate(-45deg) translateY(-22px) translateX(24px);
          position : absolute;
        }
      }
      .price {
        color : #FFFFFF;
        padding-right : 10px;
        padding-left : 10px;
        width : 90px;
        margin-right : 20px;
        text-align : left;


        .cost {
          font-size : 24px;
          color : #EEE4A0;
          &::before {
            content : '$';
            font-size : 75%;
          }
        }
      }

      .rule {
        width : 140px;
        text-align : left;
        color : #686868;
        margin-right : 20px;
        .title {
          margin-bottom : 20px;
          color : #EEE4A0;
          font-size : 14px;
          font-weight : 500;
        }

        .progress {
          position : relative;
          margin-bottom : 8px;
          .txt {
            position : absolute;
            left : 2px;
            top : 50%;
            transform : translateY(-50%);
            color : #C8C8C9 ;
            font-size : 12px;
            margin-bottom : 12px;
          }
          .bg-prosess {
            width : 100%;
            height : 12px;
            border-radius : 6px;
            background-color : rgb(222, 228, 247);
            display : flex;
            align-items : center;
          }
          .bg-line {
            background-color : rgb(222, 228, 247);
          }
          .inner {
            height : 100%;
            border-radius : 6px;
            transition : all .5s cubic-bezier(0, .64, .36, 1);
          }

          .line {
            width : 90%;
            background-color : #4187F2;
          }
        }
      }
      .tip {
        color : #C8C8C9 ;
      }
    }

    .btn {
      width : 60px;
      height : 30px;
    }
  }
}

</style>
